import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toastContainerConfig } from '../../lib/toast-config';

export function ToastProvider() {
  return <ToastContainer {...toastContainerConfig} />;
}